import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [{
  path: '/',
  name: 'Home',
  component: () => import( /* webpackChunkName: "about" */ '../views/index.vue')
}, {
  path: '/aboutUs',
  name: 'aboutUs',
  component: () => import( /* webpackChunkName: "about" */ '../views/aboutUs.vue')
}, {
  path: '/product',
  name: 'product',
  component: () => import( /* webpackChunkName: "about" */ '../views/product/index.vue')
}, {
  path: '/product/details',
  name: 'productDetails',
  component: () => import( /* webpackChunkName: "about" */ '../views/product/details.vue')
}, {
  path: '/Internet',
  name: 'InternetBox',
  component: () => import( /* webpackChunkName: "about" */ '../views/Internet/index.vue')
}, {
  path: '/Internet/HMI',
  name: 'InternetHMI',
  component: () => import( /* webpackChunkName: "about" */ '../views/Internet/HMI.vue')
}, {
  path: '/Internet/PLC',
  name: 'InternetPLC',
  component: () => import( /* webpackChunkName: "about" */ '../views/Internet/PLC.vue')
}, {
  path: '/productTechnology',
  name: 'productTechnology',
  component: () => import( /* webpackChunkName: "about" */ '../views/productTechnology.vue')
}, {
  path: '/contact',
  name: 'contact',
  component: () => import( /* webpackChunkName: "about" */ '../views/contact.vue')
}]

const router = new VueRouter({
  routes
})

export default router